import * as React from 'react'
import { Dialog } from '@lacedltd/laced-components'
import { useLocale, useCookiePopUpState } from 'hooks'
import { useSiteSettings } from './utils'
import { SiteSettingsTrigger, SiteSettingsModal } from './components'
import { SiteSettingsProps } from './types'

const SiteSettings = ({
  geoLocale,
  preferredLocale,
  isLoggedIn
}: SiteSettingsProps) => {
  const { locale, location, currency } = useLocale()
  const { showSiteSettings, updateSiteSettings, isLoading } = useSiteSettings({
    geoLocale,
    preferredLocale,
    isLoggedIn
  })

  const [hasSuggested, setHasSuggested] = React.useState(false)
  const [open, setOpen] = React.useState(false)

  const [showPopup] = useCookiePopUpState()

  React.useEffect(() => {
    window.addEventListener(
      'toggleSiteSettingsModal',
      () => setOpen(!open),
      false
    )

    return () => {
      window.removeEventListener(
        'toggleSiteSettingsModal',
        () => setOpen(!open),
        false
      )
    }
  }, [setOpen, open])

  React.useEffect(() => {
    if (showPopup) {
      setOpen(false)
    }

    if (hasSuggested && !showPopup) {
      setOpen(true)
    }
  }, [hasSuggested, showPopup])

  React.useEffect(() => {
    if (!open && showSiteSettings() && !hasSuggested && !showPopup) {
      setOpen(true)
      setHasSuggested(true)
    }
  }, [
    currency,
    hasSuggested,
    locale,
    location,
    open,
    setOpen,
    showSiteSettings,
    updateSiteSettings,
    showPopup
  ])

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
      width={465}
      drawer
      trigger={<SiteSettingsTrigger location={location} currency={currency} />}
    >
      <SiteSettingsModal
        updatePrompt={showSiteSettings()}
        dialogControls={{ open, setOpen }}
        updateSiteSettings={updateSiteSettings}
        isLoading={isLoading}
      />
    </Dialog>
  )
}

export default SiteSettings
